import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import MetaSeo from '../MetaSeo';
import useTrans from '../../hooks/useTrans';
import { getAllServices } from '../../redux/actions/services';
export default function Offshore(props) {
  const trans = useTrans();
  const [service, setService] = useState([]);
  const [value_select, setValueSelect] = useState('vi');
  const router = useRouter();
  const dispatch = useDispatch();
  useEffect(() => {
    getListServiceAll();
    setValueSelect(router.locale);
  }, router.locale);

  const getListServiceAll = async () => {
    const data = await getAllServices({}, dispatch);
    if (data) {
      setService(data?.rows);
    }
  };
  console.log('service', service);
  const settings = {
    // className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    prevArrow: (
      <button
        className='slick-prev slick-arrow'
        aria-label='Next'
        type='button'
      >
        <img src='./assets/images/home/icon-next.svg' />
      </button>
    ),
    nextArrow: (
      <button
        className='slick-next slick-arrow'
        aria-label='Next'
        type='button'
      >
        <img src='./assets/images/home/icon-next.svg' />
      </button>
    ),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const dataSeo = {
    title: 'OffShore | TCOM Corporation',
    description:
      'TCOM, trung tâm offshore, đối tác tin cậy của các khách hàng Nhật, Âu, Mỹ. Chúng tôi cung cấp dịch vụ offshore nhằm mang tới cho đối tác, khách hàng sản phẩm chất lượng với giá cả cạnh tranh nhất',
  };
  const dataSeoEN = {
    title: 'OffShore | TCOM Corporation',
    description:
      'TCOM, an offshore center, is a dependable partner for Japanese, US, Europe clients. We provide our partners and consumers with a variety of high-quality products at the most competitive pricing possible through the provision of offshore services',
  };
  return (
    <>
      {trans.seoVN ? <MetaSeo {...dataSeo} /> : <MetaSeo {...dataSeoEN} />}
      <div className='main-content'>
        {/* banner */}
        <div className='r-big-banner'>
          <div className='container'>
            <div className='title-left'>
              <h3>Offshore</h3>
              <p className='desc'>{trans.offshore.desc}</p>
            </div>
            <div className='box'>
              <div className='row'>
                <div className='col-6 col-md-4'>
                  <div className='inner'>
                    <div className='icon'>
                      <svg
                        width={72}
                        height={67}
                        viewBox='0 0 72 67'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M40.2884 22.4618C38.482 21.5586 36.4499 20.8813 34.508 20.7006V29.2356L35.7273 29.5517C37.4434 30.0033 38.9788 30.5001 40.3787 31.042C42.8624 31.9903 45.0301 33.4354 46.159 35.874C47.2428 38.1319 47.2428 42.0607 45.9784 44.5896C43.9462 48.6991 39.4755 50.1442 34.9145 50.3248V54.2536C34.9145 55.0665 34.2371 55.7439 33.4242 55.7439C32.6114 55.7439 31.934 55.0665 31.934 54.2536V50.2345C28.3665 49.9635 24.8892 48.97 21.9539 47.4346C18.0702 45.4476 21.2765 39.8028 24.9795 41.7446C27.0568 42.8284 29.8567 43.8219 32.3856 44.0929V35.603C31.3921 35.3772 28.3213 34.5192 26.244 33.616C22.1345 31.8097 20.6894 29.1453 20.6894 25.6229C20.6894 20.8361 23.3087 17.3137 27.5084 15.688C28.9084 15.1461 30.3534 14.83 31.934 14.6945V11.127C31.934 10.3141 32.6114 9.63672 33.4242 9.63672C34.2371 9.63672 34.9145 10.3141 34.9145 11.127V14.6493C37.4885 14.83 40.1529 15.4622 42.9527 16.8621C44.5333 17.6298 45.1655 19.5717 44.3075 21.1522C43.5398 22.5973 41.7786 23.1843 40.2884 22.4618ZM27.7342 24.5391C27.7342 25.6681 28.1407 26.5261 28.9084 27.068C29.6761 27.6551 30.8502 28.1518 32.4307 28.6034V20.6103C29.3148 20.8361 27.7342 22.1457 27.7342 24.5391ZM39.7465 40.5705C39.7465 39.4415 39.2949 38.5835 38.3465 37.9513C37.4434 37.319 36.1338 36.732 34.508 36.2352V44.1832C37.9853 44.0929 39.7465 42.8736 39.7465 40.5705Z'
                          fill='white'
                        />
                        <path
                          d='M69.6438 24.628H65.5344C61.4249 9.4998 46.9289 -1.42861 30.175 0.151947C14.1436 1.64219 1.31853 14.6931 0.0992422 30.7696C-1.391 50.3234 14.0985 66.6709 33.3361 66.6709C45.6193 66.6709 56.3671 59.9874 62.1474 50.0524C62.87 48.788 62.3732 47.1623 61.0185 46.5752C61.0185 46.5752 60.9733 46.5752 60.9733 46.53C59.8443 46.0333 58.4896 46.4397 57.9025 47.4784C52.6641 56.5101 42.5937 62.3808 31.2588 61.6131C17.2596 60.6196 5.96988 49.3299 4.97639 35.3306C3.80226 18.7574 16.9435 4.84845 33.291 4.84845C45.9354 4.84845 56.6381 13.1125 60.3411 24.5377H56.051C54.1995 24.5377 53.0705 26.5699 54.1092 28.1504L60.8378 38.5821C61.741 39.982 63.8183 40.0272 64.7666 38.5821L71.6308 28.1504C72.6243 26.7053 71.4953 24.628 69.6438 24.628Z'
                          fill='white'
                        />
                      </svg>
                    </div>
                    <h3>{trans.offshore.note1}</h3>
                  </div>
                </div>
                <div className='col-6 col-md-4'>
                  <div className='inner'>
                    <div className='icon'>
                      <svg
                        width={80}
                        height={60}
                        viewBox='0 0 80 60'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0_401_10712)'>
                          <path
                            d='M0 4.84222C0.542656 3.33948 1.48187 2.21243 3.15158 1.98284C3.69423 1.89936 4.2995 1.9411 4.84216 2.0872C11.9384 3.92388 19.1599 4.19521 26.4023 3.46471C33.3107 2.77595 40.1983 1.81587 47.1067 1.00189C53.4307 0.250517 59.7548 -0.292138 66.1205 0.167032C69.8565 0.43836 73.5716 1.02276 77.1824 2.00371C78.9564 2.48375 80 3.84039 80 5.6562C80 21.6437 80 37.652 80 53.6395C80 56.2067 77.8294 57.8347 75.2831 57.3337C72.6115 56.812 69.9191 56.2693 67.2267 55.9354C62.7602 55.3718 58.2938 55.5179 53.8064 55.8727C51.6984 56.0397 49.6113 56.311 47.5241 56.5197C46.5641 56.6241 45.7709 56.0397 45.6666 55.1422C45.5622 54.3074 46.1675 53.556 47.1067 53.4308C56.0397 52.2829 64.9517 51.8654 73.8429 53.7647C74.4691 53.9108 75.1161 54.0778 75.7422 54.203C76.6606 54.4117 76.8902 54.2239 76.8902 53.3056C76.8902 53.1177 76.8902 52.9507 76.8902 52.7629C76.8902 37.2972 76.8902 21.8107 76.8902 6.34496C76.8902 5.11355 76.8902 5.11355 75.7214 4.84222C68.8547 3.13077 61.8836 2.71334 54.8709 3.42297C47.7746 4.13259 40.6992 5.05093 33.6238 5.90666C27.7589 6.61629 21.8732 7.13807 15.9457 6.86674C12.0845 6.6789 8.26507 6.17799 4.52909 5.21791C3.27681 4.90483 3.13071 5.00919 3.13071 6.32409C3.13071 21.9359 3.13071 37.5268 3.10984 53.1386C3.10984 53.9526 3.33942 54.3283 4.17428 54.537C11.1244 56.2693 18.1581 56.645 25.2544 56.0188C27.8216 55.7893 30.3887 55.4971 32.935 55.2466C33.916 55.1422 34.6882 55.7058 34.8135 56.6032C34.9178 57.4381 34.3334 58.2103 33.3942 58.3356C25.1918 59.3791 16.9684 59.9844 8.72424 58.6278C6.82494 58.3147 4.94652 57.8555 3.06809 57.459C1.44013 57.125 0.521785 56.0606 0 54.5578C0 37.986 0 21.4141 0 4.84222Z'
                            fill='white'
                          />
                          <path
                            d='M39.9868 45.3327C31.367 45.3327 24.3542 38.2991 24.375 29.6583C24.3959 21.0802 31.4087 14.0674 40.0077 14.0674C48.6276 14.0674 55.6404 21.101 55.6195 29.7418C55.5986 38.3408 48.5859 45.3327 39.9868 45.3327Z'
                            fill='white'
                          />
                          <path
                            d='M40.2611 54.3701C41.1168 54.391 41.7847 55.0589 41.7847 55.9146C41.7847 56.7703 41.096 57.4591 40.2403 57.4591C39.3637 57.4591 38.6749 56.7286 38.6958 55.852C38.7166 54.9963 39.4054 54.3492 40.2611 54.3701Z'
                            fill='white'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_401_10712'>
                            <rect width={80} height='59.4' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <h3>{trans.offshore.note2}</h3>
                  </div>
                </div>
                <div className='col-12 col-md-4'>
                  <div className='inner'>
                    <div className='icon'>
                      <svg
                        width={80}
                        height={82}
                        viewBox='0 0 80 82'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <g clipPath='url(#clip0_401_10720)'>
                          <path
                            d='M72.7165 0C73.2049 0.127422 73.6721 0.254845 74.1606 0.403504C77.6647 1.52907 79.9371 4.65092 79.9795 8.5373C80.022 12.6998 80.0432 16.8622 79.9795 21.0035C79.9158 25.9729 76.348 29.6045 71.3998 29.4558C68.915 29.3921 66.94 30.0292 65.0499 31.6007C62.9049 33.3634 60.5901 34.9137 58.3389 36.549C58.1478 36.6764 57.9567 36.8038 57.6594 37.0162C57.6594 34.4465 57.6594 31.983 57.6594 29.477C56.0029 29.1372 54.5163 28.5214 53.2845 27.417C51.4794 25.7818 50.5025 23.7643 50.4812 21.3432C50.4387 18.6461 50.4812 15.949 50.4812 13.1882C51.2882 13.1882 52.0315 13.1882 52.8598 13.1882C52.8598 14.3138 52.8598 15.3756 52.8598 16.4587C52.8598 17.9666 52.8598 19.4744 52.8598 20.9822C52.881 24.5076 55.3658 27.0348 58.8699 27.141C59.2097 27.141 59.5495 27.141 59.953 27.141C59.953 28.8612 59.953 30.5177 59.953 32.3653C60.314 32.1317 60.5476 31.983 60.76 31.8344C62.735 30.3902 64.6888 28.9461 66.6639 27.5445C66.9824 27.3109 67.4284 27.1834 67.8107 27.1622C69.0212 27.1197 70.253 27.1622 71.4635 27.141C74.9676 27.0773 77.4948 24.635 77.5585 21.1521C77.6222 16.8835 77.6435 12.6148 77.5585 8.3674C77.4948 4.82081 74.9251 2.39979 71.3785 2.39979C67.2798 2.39979 63.1598 2.39979 59.061 2.39979C55.3658 2.39979 52.8385 4.94824 52.8385 8.64348C52.8385 9.30183 52.8385 9.96018 52.8385 10.6822C52.0315 10.6822 51.2882 10.6822 50.5449 10.6822C49.8653 5.45792 52.1377 1.86886 56.2152 0.424741C56.6825 0.254845 57.1709 0.148659 57.6381 0C62.6501 0 67.6833 0 72.7165 0Z'
                            fill='white'
                          />
                          <path
                            d='M11.5317 79.0017C14.3138 79.0017 16.9896 79.0017 19.6655 79.0017C20.7698 79.0017 21.8954 78.938 22.9997 79.0229C24.2952 79.1291 25.081 78.938 25.6968 77.4939C26.695 75.1365 28.8399 74.0747 31.3884 74.2871C33.9156 74.4994 35.657 75.8798 36.5277 78.2796C36.7401 78.853 36.9737 79.0654 37.5684 79.0229C38.3329 78.9592 39.0974 79.0017 39.9257 79.0017C39.9257 79.7875 39.9257 80.5307 39.9257 81.3378C26.6525 81.3378 13.3793 81.3378 0 81.3378C0.0849482 80.0848 0.148659 78.853 0.233608 77.6213C0.552163 73.5862 0.828245 69.53 1.18928 65.4949C1.35917 63.6898 1.80515 61.9483 2.69711 60.3556C4.0138 57.977 6.17998 56.5966 8.60101 55.6622C13.2094 53.8783 17.8604 52.2005 22.5113 50.5228C23.1272 50.2892 23.382 49.9706 23.4032 49.3335C23.4457 48.4416 23.8492 47.401 23.5307 46.6789C23.2333 46.0205 22.1927 45.702 21.4919 45.1923C17.7542 42.4952 15.0146 39.076 14.0165 34.4464C13.8466 33.6606 13.7829 32.8111 13.7829 32.0041C13.7616 28.1814 13.7616 24.38 13.7829 20.5573C13.8041 12.8907 19.5593 7.15674 27.2259 7.15674C33.8731 7.15674 40.5203 7.15674 47.1675 7.15674C47.4224 7.15674 47.6984 7.15674 48.0807 7.15674C48.0807 7.49653 48.0807 7.81509 48.0807 8.11241C48.0807 15.779 47.9958 23.4243 48.1019 31.0909C48.1656 35.5507 46.4879 39.2247 43.5572 42.4315C42.1556 43.9818 40.5415 45.256 38.6939 46.2329C38.2692 46.4665 38.1205 46.7214 38.2055 47.1673C38.2692 47.5071 38.3541 47.8682 38.3116 48.1867C38.0993 49.8857 39.055 50.4803 40.5203 50.99C44.6403 52.3917 48.7178 53.9632 52.8166 55.4923C53.0077 55.556 53.1988 55.6622 53.4112 55.7471C57.7011 57.4461 60.1858 60.5892 60.6106 65.1764C61.1203 70.5493 61.4813 75.9436 61.906 81.3802C56.979 81.3802 52.137 81.3802 47.2312 81.3802C47.2312 80.6369 47.2312 79.8936 47.2312 79.0654C48.2294 79.0654 49.2275 79.0654 50.2681 79.0654C50.2894 78.7681 50.3106 78.5345 50.3106 78.3009C50.3106 73.926 50.3106 69.5512 50.3106 65.1976C50.3106 63.9446 49.9496 63.5623 48.7178 63.5623C36.8463 63.5623 24.9748 63.5623 13.1033 63.5623C11.914 63.5623 11.5317 63.9446 11.5317 65.1127C11.5317 69.5087 11.5317 73.9048 11.5317 78.3009C11.5317 78.492 11.5317 78.7044 11.5317 79.0017ZM45.6809 30.2839C45.6809 29.8379 45.6809 29.3919 45.6809 28.9247C45.6809 27.1408 45.6809 27.1196 43.9395 26.7798C36.464 25.2719 29.0098 23.7853 21.5344 22.2775C21.0459 22.1713 20.7061 22.2563 20.3451 22.6385C19.4319 23.6155 18.4975 24.6348 17.4781 25.4843C16.4162 26.355 16.0127 27.3532 16.1402 28.7123C16.3101 30.5175 16.0552 32.4076 16.4375 34.1703C17.4569 38.715 20.4088 41.9218 24.3801 44.1942C27.1834 45.7869 30.2203 46.3391 33.4271 45.6808C37.2073 44.9162 40.1805 42.8562 42.5591 39.9043C44.8527 37.1222 46.0844 33.9579 45.6809 30.2839ZM2.54845 78.9592C4.79957 78.9592 6.94452 78.9592 9.15317 78.9592C9.15317 78.6406 9.15317 78.3433 9.15317 78.0673C9.15317 73.7561 9.15317 69.4238 9.15317 65.1127C9.15317 62.5642 10.5761 61.1413 13.1457 61.1413C24.9748 61.1413 36.8251 61.1413 48.6541 61.1413C51.2875 61.1413 52.6891 62.543 52.6891 65.1551C52.6891 69.4662 52.6891 73.7986 52.6891 78.1097C52.6891 78.3858 52.6891 78.6619 52.6891 78.9592C54.9403 78.9592 57.0852 78.9592 59.2726 78.9592C59.1877 77.7699 59.124 76.6231 59.039 75.4976C58.7842 72.2058 58.5293 68.8928 58.2532 65.6011C57.9347 62.012 56.1933 59.3999 52.7953 58.0832C49.2487 56.7028 45.6809 55.4073 42.1131 54.0694C40.9026 53.6234 39.6921 53.1987 38.4815 52.7527C37.356 56.2993 35.1261 58.5079 31.4096 58.6991C27.2259 58.9114 24.6562 56.6391 23.3608 52.7527C20.4513 53.8145 17.5843 54.8339 14.7385 55.917C12.4662 56.7877 10.1938 57.6372 7.98513 58.6566C5.69153 59.6972 4.28989 61.5873 3.88638 64.072C3.56783 66.0471 3.35546 68.0646 3.18556 70.0609C2.93071 72.9704 2.76082 75.9435 2.54845 78.9592ZM45.6597 9.57776C45.4048 9.55652 45.1925 9.55652 44.9801 9.55652C38.9488 9.55652 32.9174 9.53529 26.8649 9.55652C20.6637 9.599 14.9934 14.7384 16.2888 23.3606C17.4144 22.235 18.4975 21.152 19.5593 20.0476C19.8779 19.7078 20.1752 19.6016 20.6637 19.6866C27.1834 21.0033 33.7244 22.2988 40.2655 23.6155C42.0494 23.9765 43.8333 24.3163 45.6597 24.6773C45.6597 19.6017 45.6597 14.6322 45.6597 9.57776ZM25.9942 47.4859C25.8667 48.6752 25.7393 49.7583 25.6756 50.8201C25.5269 53.4748 27.4383 55.8745 30.008 56.2568C32.79 56.6815 35.4659 55.0888 35.9756 52.3917C36.2729 50.8414 36.0181 49.1636 35.9968 47.4434C32.5352 48.5902 29.3071 48.6115 25.9942 47.4859ZM34.2341 78.9804C33.6395 77.4089 32.2591 76.5169 30.6875 76.6231C29.2434 76.7081 27.948 77.7275 27.6931 78.9804C29.8381 78.9804 32.0042 78.9804 34.2341 78.9804Z'
                            fill='white'
                          />
                          <path
                            d='M65.4533 19.5381C64.6463 19.3682 63.9454 19.2408 63.1172 19.0709C63.7331 16.034 64.3277 13.0608 64.9436 10.0239C65.7506 10.1938 66.4726 10.3212 67.2796 10.4911C66.6638 13.528 66.0691 16.5012 65.4533 19.5381Z'
                            fill='white'
                          />
                          <path
                            d='M59.5275 18.6675C58.2108 17.3509 56.9153 16.0554 55.6836 14.8449C56.9578 13.5707 58.2533 12.2752 59.5912 10.9585C59.9735 11.4045 60.4832 11.9566 61.0778 12.615C60.4195 13.1884 59.6124 13.8892 58.7205 14.675C59.6762 15.5669 60.4619 16.2678 61.2477 17.0111C60.5893 17.6269 60.0584 18.1579 59.5275 18.6675Z'
                            fill='white'
                          />
                          <path
                            d='M71.6107 14.7384C70.7613 13.9314 69.9967 13.2306 69.2109 12.4873C69.8268 11.9139 70.4002 11.4042 70.8887 10.937C72.1417 12.1688 73.4371 13.4642 74.6689 14.696C73.4371 15.949 72.1204 17.2657 70.8037 18.6036C70.3577 18.1576 69.8481 17.6054 69.2109 16.9471C69.9542 16.2675 70.7188 15.5455 71.6107 14.7384Z'
                            fill='white'
                          />
                          <path
                            d='M44.7255 81.3593C43.9397 81.3593 43.2177 81.3593 42.4531 81.3593C42.4531 80.5947 42.4531 79.8727 42.4531 79.0869C43.1964 79.0869 43.9397 79.0869 44.7255 79.0869C44.7255 79.809 44.7255 80.5523 44.7255 81.3593Z'
                            fill='white'
                          />
                          <path
                            d='M38.4811 14.2711C37.6953 14.2711 36.9733 14.2711 36.1875 14.2711C36.1875 13.5066 36.1875 12.7633 36.1875 11.9775C36.9308 11.9775 37.6953 11.9775 38.4811 11.9775C38.4811 12.7208 38.4811 13.4429 38.4811 14.2711Z'
                            fill='white'
                          />
                          <path
                            d='M43.2623 11.9565C43.2623 12.7423 43.2623 13.4644 43.2623 14.2501C42.4978 14.2501 41.7545 14.2501 40.9688 14.2501C40.9688 13.4856 40.9688 12.7423 40.9688 11.9565C41.7333 11.9565 42.4553 11.9565 43.2623 11.9565Z'
                            fill='white'
                          />
                        </g>
                        <defs>
                          <clipPath id='clip0_401_10720'>
                            <rect width={80} height='81.3592' fill='white' />
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    <h3>{trans.offshore.note3}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end banner */}
        {/* service */}
        <div className='r-service'>
          <div className='container'>
            <div className='title-left'>
              <h3>{trans.offshore.sv}</h3>
            </div>
            <div className='row'>
              {service.map((item, index) => {
                return (
                  <div className='col-12 col-md-4'>
                    <Link href={`/${router.locale}/service/${item?.seo_url}`}>
                      <a className='box'>
                        <div className='icon'>
                          <img width={58} height={58} src={item.image} alt='' />
                        </div>
                        <h3>{item.title}</h3>
                        <div className='arrow'>
                          <svg
                            width={24}
                            height={24}
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                          >
                            <path
                              d='M7 2L17 12L7 22'
                              stroke='#0063AA'
                              strokeWidth={2}
                            />
                          </svg>
                        </div>
                      </a>
                    </Link>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* end service */}
        {/* technology */}
        <div className='r-technology'>
          <div className='container'>
            <div className='title-left'>
              <h3>{trans.offshore.tech}</h3>
            </div>
            <div className='row'>
              <div className='col-12 col-md-6'>
                <div className='box backend'>
                  <h3>Backend</h3>
                  <ul>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/nodejs-2 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>NodeJS</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/c--4 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>C#</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/python-5.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>NetCore</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/golang 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Golang</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img src='/assets/images/iconOffShore/c++.svg' alt='' />
                      </div>
                      <div className='name'>C++</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/php-1 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>PHP</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/jenkins 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Jenkins</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/gitlab 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Gitlab</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/docker 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Docker</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/aws-2 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>AWS</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box frontend'>
                  <h3>Frontend</h3>
                  <ul>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/react.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>ReactJS</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/angular-icon-1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Angular</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/next-js 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>NextJS</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/electron-1 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Electron</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/html-1 4.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Html</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/css-3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Css</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/javascript-1 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>JS</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/qt 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Qt</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/jquery-1 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Jquery</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/bootstrap-5-1 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Bootstrap</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box mobility'>
                  <h3>Mobility</h3>
                  <ul>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/android.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Android</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/ios-2.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Ios</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/swift-15 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Swift</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/obj-c.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Objective-C</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/java-4 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Java</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/react-native-1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>React Native</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/c++2.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>C++</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/kotlin-1 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Kotlin</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box ai'>
                  <h3>A.I</h3>
                  <ul>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/tensorflow-2 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Tensorflow</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/python-5-2).svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Python</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/pytorch-seeklogo.com 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>PyTorch</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/machine.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Machine learning</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/deep.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Deep learning</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/opencv.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>OpenCV</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/face.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Face Recognition</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box blockchain'>
                  <h3>Blockchain</h3>
                  <ul>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/ethereum-1 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Ethereum</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/smart.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Smart Contract</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/binance-logo 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Binance Chain</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/polygon.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Polygon</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/avalanche.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Avalanche</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/cosmos-atom-logo 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Cosmos</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/solana-sol-logo 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Solana</div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box database'>
                  <h3>DataBase</h3>
                  <ul>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/mysql-6 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>MySQL</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/sql-server-magazine-network 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>SQL Server</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/redis 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Redis</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/mongodb-icon-1 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Mongo</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/elastic-elasticsearch 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>Elastic Search</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/graphql 3.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>GraphQL</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/mysql.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>MySQL</div>
                    </li>
                    <li>
                      <div className='icon'>
                        <img
                          src='/assets/images/iconOffShore/aws-rds 1.svg'
                          alt=''
                        />
                      </div>
                      <div className='name'>AWS RDS</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end technology */}
        {/* cooperate */}
        <div className='r-cooperate'>
          <div className='container'>
            <div className='title-left'>
              <h3>{trans.offshore.corp}</h3>
            </div>
            <div className='step step-1'>
              <div className='inner'>
                <div className='number'>1</div>
                <div className='content'>
                  <h3>Project based</h3>
                  <p>{trans.offshore.base}</p>
                  <p>{trans.offshore.base_desc}</p>
                </div>
                <div className='image'>
                  <img
                    className='w-100'
                    src='/assets/images/offshore/imgCustomer_Tcom.png'
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className='step step-2'>
              <div className='inner'>
                <div className='number'>2</div>
                <div className='content'>
                  <h3>Dedicated team (labor)</h3>
                  <p>{trans.offshore.dedicate}</p>
                  <p>{trans.offshore.dedicate_desc}</p>
                </div>
                <div className='image'>
                  <div className='row'>
                    <div className='col-12 col-md-6'>
                      <div className='box'>
                        <div className='top'>
                          <h5>Pattern 1</h5>
                          <p>{trans.offshore.pattern_des1}</p>
                        </div>
                        <img
                          className='img_customer_tcom'
                          src='/assets/images/offshore/imgCustomer_Tcom2.png'
                          alt=''
                        />
                      </div>
                    </div>
                    <div className='col-12 col-md-6'>
                      <div className='box'>
                        <div className='top'>
                          <h5>Pattern 2</h5>
                          <p>{trans.offshore.pattern_des2}</p>
                        </div>
                        <img
                          className='img_customer_tcom'
                          src='/assets/images/offshore/imgCustomer_Tcom3.png'
                          alt=''
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end cooperate */}
        {/* reason */}
        <div className='r-reason'>
          <div className='container'>
            {/* <div className='label'>
                        <img src='/assets/images/offshore/why.png' alt='' />
                    </div> */}
            <h1>{trans.offshore.question}</h1>
            <div className='row'>
              <div className='col-12 col-md-6'>
                <div className='box'>
                  <div className='number'>01</div>
                  <h3>{trans.offshore.answer1}</h3>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box'>
                  <div className='number'>04</div>
                  <h3>{trans.offshore.answer4}</h3>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box'>
                  <div className='number'>02</div>
                  <h3>{trans.offshore.answer2}</h3>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box'>
                  <div className='number'>05</div>
                  <h3>{trans.offshore.answer5}</h3>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box'>
                  <div className='number'>03</div>
                  <h3>{trans.offshore.answer3}</h3>
                </div>
              </div>
              <div className='col-12 col-md-6'>
                <div className='box'>
                  <div className='number'>06</div>
                  <h3>{trans.offshore.answer6}</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end reason */}
        {/* step */}
        {/* <div className='r-step'>
                    <div className='container'>
                        <div className='title-center'>
                            <h3>Quy trình thực hiện</h3>
                            <p className='desc'>Các bước trao đổi, làm việc đơn giản, rõ ràng, dễ dàng hợp tác</p>
                        </div>
                        <Slider {...settings}>
                            <div className='item'>
                                <div className='top'>
                                    <div className='number'>1</div>
                                    <div className='text'>step</div>
                                </div>
                                <h3>Thu thập thông tin</h3>
                                <p>Trao đổi idea, tư vấn, nghiên cứu và làm rõ các yêu cầu</p>
                            </div>
                            <div className='item'>
                                <div className='top'>
                                    <div className='number'>2</div>
                                    <div className='text'>step</div>
                                </div>
                                <h3>Thiết kế</h3>
                                <p>Thiết kế kiến trúc hệ thống, phác thảo giao diện, thiết kế UI/UX</p>
                            </div>
                            <div className='item'>
                                <div className='top'>
                                    <div className='number'>3</div>
                                    <div className='text'>step</div>
                                </div>
                                <h3>Triển khai</h3>
                                <p>Lập trình các chức năng</p>
                            </div>
                            <div className='item'>
                                <div className='top'>
                                    <div className='number'>4</div>
                                    <div className='text'>step</div>
                                </div>
                                <h3>Testing</h3>
                                <p>Quản lý chất lượng, kiểm thử phần mềm, fix lỗi</p>
                            </div>
                            <div className='item'>
                                <div className='top'>
                                    <div className='number'>5</div>
                                    <div className='text'>step</div>
                                </div>
                                <h3>Triển khai</h3>
                                <p>Triển khai chạy thử, chạy beta và chạy production</p>
                            </div>
                            <div className='item'>
                                <div className='top'>
                                    <div className='number'>6</div>
                                    <div className='text'>step</div>
                                </div>
                                <h3>Đánh giá</h3>
                                <p>Đánh giá chất lượng, hiệu năng</p>
                            </div>
                        </Slider>
                    </div>
                </div> */}
        <div className='r-process'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-12 col-lg-5'>
                <div className='col-left'>
                  <div className='subtract-2'>
                    <img src='/assets/images/offshore/Subtract-2.png' alt='' />
                  </div>
                  <h3>{trans.offshore.corp_title}</h3>
                  {/* <p>Các bước trao đổi, làm việc đơn giản, rõ ràng, dễ dàng hợp tác</p> */}
                  <div className='subtract'>
                    <img src='/assets/images/offshore/Subtract.png' alt='' />
                  </div>
                </div>
              </div>
              <div className=' col-md-12 col-lg-7'>
                <div className='col-right'>
                  <ul>
                    <li>
                      <div className='icon'>
                        <svg
                          width='65'
                          height='65'
                          viewBox='0 0 65 65'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='31.5'
                            fill='#0063AA'
                            stroke='white'
                          />
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='28'
                            fill='white'
                          />
                          <g clip-path='url(#clip0_492_29506)'>
                            <path
                              d='M48.5323 29.5525C48.4931 29.8813 48.4618 30.21 48.4148 30.5388C47.8276 34.7267 45.6588 37.8343 41.971 39.8773C40.6399 40.621 39.1836 41.0202 37.6803 41.2237C37.3906 41.2629 37.1401 41.0828 37.1087 40.8167C37.0774 40.574 37.2497 40.3705 37.5394 40.2922C38.4633 40.0652 39.4263 39.9165 40.3111 39.5799C42.7461 38.6719 44.6253 37.0593 45.9641 34.8363C47.1229 32.9106 47.6554 30.8128 47.5692 28.574C47.4518 25.4429 46.2069 22.7971 43.9363 20.6445C43.9049 20.621 43.8736 20.5975 43.7953 20.5505C43.7953 21.0828 43.7875 21.5838 43.8031 22.077C43.8031 22.1709 43.9049 22.2726 43.9832 22.3588C45.1107 23.6817 45.8702 25.2002 46.2147 26.9067C46.6923 29.2629 46.4183 31.5329 45.3064 33.6699C44.0459 36.0965 42.1198 37.8343 39.5046 38.6875C36.1927 39.7678 33.0608 39.3059 30.2186 37.2863C28.0654 35.7521 26.6874 33.6543 26.1941 31.0711C25.466 27.2981 26.5308 24.0417 29.3652 21.4194C31.2521 19.6738 33.5306 18.8206 36.0987 18.7658C37.0383 18.7501 37.97 18.8754 38.8783 19.1259C38.9879 19.1572 39.0975 19.1807 39.2463 19.2198C39.2463 18.8441 39.2619 18.4997 39.2384 18.1631C39.2306 18.0926 39.1053 17.9987 39.0114 17.9752C37.4454 17.5681 35.8638 17.482 34.2744 17.7795C30.6414 18.4605 27.9167 20.4331 26.1472 23.6738C24.9179 25.9361 24.5186 28.3783 25.004 30.9067C25.9044 35.5799 28.7075 38.5858 33.2409 39.9713C33.8203 40.1513 34.4466 40.1983 35.0495 40.3C35.1748 40.3235 35.3001 40.3314 35.4175 40.3548C35.7072 40.4175 35.8717 40.6288 35.8325 40.8793C35.7934 41.1298 35.5663 41.2942 35.2766 41.2707C34.1726 41.1689 33.0921 40.9576 32.0508 40.5818C30.5553 40.0417 29.2086 39.2511 28.0185 38.1944C27.9558 38.1396 27.8932 38.0926 27.8149 38.03C27.5174 38.3509 27.2355 38.664 26.9223 39.0085C27.0632 39.1337 27.2433 39.2903 27.4077 39.4625C27.948 40.0182 27.948 40.7071 27.4077 41.2707C26.8988 41.7952 26.3821 42.304 25.8653 42.8206C24.1428 44.5427 22.4202 46.2648 20.6977 47.9869C19.7816 48.9028 18.8029 48.9028 17.8868 47.9869C17.5815 47.6738 17.2526 47.3764 16.9708 47.0476C16.3679 46.3353 16.3757 45.3881 16.9864 44.6758C17.0647 44.5818 17.1587 44.4879 17.2448 44.4018C19.4136 42.2257 21.5903 40.0574 23.7669 37.8813C24.4873 37.1611 25.1293 37.1611 25.8418 37.8734C25.9671 37.9987 26.061 38.1474 26.1941 38.3274C26.5386 37.9361 26.8127 37.6308 27.0946 37.3098C26.7422 36.8402 26.3272 36.3392 25.9671 35.7991C24.8474 34.1396 24.1819 32.3079 23.9783 30.3118C23.6651 27.3999 24.2915 24.6836 25.9201 22.2335C27.8854 19.2824 30.6414 17.4742 34.1491 16.8558C34.5484 16.7854 34.9478 16.7306 35.3471 16.6758C35.9108 16.6758 36.4745 16.6758 37.0383 16.6758C37.7978 16.8089 38.5572 16.9419 39.3167 17.0672C39.3715 17.075 39.4342 17.0515 39.4811 17.028C39.6456 16.9184 39.81 16.7932 39.9744 16.6758C41.0158 16.6758 42.0571 16.6758 43.0985 16.6758C43.6465 16.9263 43.858 17.3568 43.811 17.9517C43.7875 18.2727 43.8188 18.5936 43.8031 18.9145C43.7875 19.1807 43.8736 19.3451 44.0772 19.5173C46.2538 21.3255 47.6554 23.619 48.2504 26.3901C48.3835 26.9928 48.4462 27.619 48.5401 28.2296C48.5323 28.6758 48.5323 29.1141 48.5323 29.5525ZM40.2015 17.6308C40.2015 24.2139 40.2015 30.7815 40.2015 37.3803C40.3033 37.3333 40.3816 37.3098 40.4442 37.2785C41.2585 36.8636 41.9867 36.3314 42.6522 35.713C42.8009 35.5721 42.8636 35.4312 42.8636 35.2276C42.8557 33.5995 42.8557 31.9791 42.8636 30.3509C42.8636 30.2257 42.8714 30.1004 42.8949 29.983C42.9419 29.7325 43.1063 29.6073 43.3647 29.6151C43.6152 29.6308 43.764 29.7717 43.7953 30.0222C43.811 30.1239 43.8031 30.2335 43.8031 30.3353C43.8031 31.5408 43.8031 32.7541 43.8031 33.9595C43.8031 34.0613 43.811 34.1552 43.8188 34.2883C46.0894 31.3451 46.0268 26.5779 43.8031 23.7286C43.8031 23.8695 43.8031 23.9635 43.8031 24.0652C43.8031 25.255 43.8031 26.437 43.8031 27.6269C43.8031 27.7286 43.8031 27.8382 43.7875 27.94C43.7562 28.1826 43.6074 28.3157 43.3725 28.3314C43.1298 28.347 42.9497 28.2296 42.8949 27.9791C42.8714 27.846 42.8636 27.713 42.8636 27.5799C42.8636 24.394 42.8636 21.2081 42.8636 18.0222C42.8636 17.8969 42.8636 17.7795 42.8636 17.6386C41.9632 17.6308 41.1019 17.6308 40.2015 17.6308ZM39.0975 20.2374C35.6759 18.985 30.8763 19.9478 28.2925 24.1513C27.3686 25.6543 26.9145 27.2981 26.8988 29.0672C26.8753 30.9224 27.6896 33.1689 28.3943 33.9126C28.3943 33.7873 28.3943 33.6699 28.3943 33.5603C28.3943 31.8539 28.3943 30.1474 28.3943 28.4409C28.3943 27.713 28.7623 27.3529 29.4904 27.3451C30.2108 27.3372 30.9311 27.3451 31.6436 27.3451C31.7532 27.3451 31.8628 27.3451 31.996 27.3451C32.0038 27.2042 32.0116 27.1024 32.0116 27.0006C32.0116 26.3353 32.0116 25.6699 32.0116 25.0045C32.0116 24.1278 32.3405 23.7912 33.2096 23.7912C34.0004 23.7912 34.7912 23.7912 35.6054 23.7912C35.6133 23.6582 35.6211 23.5408 35.6211 23.4312C35.6211 22.758 35.6211 22.077 35.6211 21.4038C35.6211 20.5975 35.9734 20.2374 36.7799 20.2374C37.555 20.2374 38.3302 20.2374 39.0975 20.2374ZM36.592 21.1846C36.592 26.9067 36.592 32.5897 36.592 38.3666C37.3906 38.2022 38.1501 38.0456 38.9174 37.8969C39.1836 37.85 39.2541 37.7169 39.2541 37.4507C39.2463 32.1435 39.2463 26.8284 39.2463 21.5212C39.2463 21.4116 39.2384 21.302 39.2306 21.1768C38.338 21.1846 37.4767 21.1846 36.592 21.1846ZM32.9512 24.7462C32.9512 24.9184 32.9512 25.0515 32.9512 25.1846C32.9512 29.2002 32.9512 33.2237 32.9512 37.2394C32.9512 37.8265 32.8572 37.6856 33.4053 37.8656C34.1178 38.1004 34.846 38.2413 35.5976 38.2648C35.5976 33.7404 35.5976 29.2394 35.5976 24.7384C34.7129 24.7462 33.8516 24.7462 32.9512 24.7462ZM29.3339 28.3C29.3339 28.4566 29.3339 28.5818 29.3339 28.7071C29.3339 30.4449 29.3339 32.1826 29.3339 33.9204C29.3339 34.3666 29.2007 34.8832 29.3887 35.2433C29.6079 35.6738 30.0698 35.9869 30.4692 36.3C30.9389 36.668 31.4557 36.9732 31.996 37.3333C31.996 34.257 31.996 31.2903 31.996 28.2922C31.1112 28.3 30.2421 28.3 29.3339 28.3ZM21.3084 41.6777C20.1105 42.8754 18.9125 44.0574 17.7302 45.2629C17.3544 45.6386 17.3701 46.1317 17.7459 46.5231C18.0278 46.8284 18.3331 47.1181 18.6306 47.4077C19.0848 47.8539 19.5232 47.8539 19.9852 47.392C21.1048 46.2726 22.2245 45.1533 23.3441 44.0339C23.4068 43.9713 23.4616 43.9008 23.4929 43.8617C22.7569 43.1259 22.0444 42.4135 21.3084 41.6777ZM25.5756 41.8186C25.9671 41.4194 26.3586 41.0202 26.7501 40.621C26.9066 40.4566 26.9301 40.2922 26.7657 40.1278C26.1941 39.5564 25.6226 38.9772 25.0432 38.4057C24.8944 38.257 24.73 38.2492 24.5812 38.4057C24.1741 38.8128 23.7591 39.2276 23.3676 39.6269C24.0958 40.3548 24.8161 41.0672 25.5756 41.8186ZM22.0287 40.9811C22.7647 41.7169 23.4772 42.4292 24.1741 43.1259C24.3777 42.9145 24.5969 42.6953 24.7535 42.531C24.0566 41.8265 23.3363 41.1063 22.6238 40.3862C22.4437 40.5662 22.2401 40.7697 22.0287 40.9811Z'
                              fill='#0063AA'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_492_29506'>
                              <rect
                                width='32'
                                height='32'
                                fill='white'
                                transform='translate(16.5312 16.6758)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='content'>
                        <p>01</p>
                        <div className='text text-white'>
                          <div>
                            <strong>{trans.offshore.step1}</strong>
                          </div>
                          {/* <span>Trao đổi idea, tư vấn, nghiên cứu và làm rõ các yêu cầu
                                                    </span> */}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='icon'>
                        <svg
                          width='65'
                          height='65'
                          viewBox='0 0 65 65'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='31.5'
                            fill='#0063AA'
                            stroke='white'
                          />
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='28'
                            fill='white'
                          />
                          <g clip-path='url(#clip0_492_29514)'>
                            <path
                              d='M29.9562 52.7224C29.8098 52.6701 29.6633 52.6178 29.5169 52.5655C28.4812 52.1994 27.7803 51.237 27.7699 50.1177C27.7594 49.0506 27.7699 47.9836 27.7699 46.9166C27.749 46.8852 27.728 46.8643 27.7071 46.8538C26.2112 46.3203 25.6045 45.4625 25.594 43.8516C25.594 42.7008 25.6045 41.5606 25.2593 40.4413C24.9036 39.301 24.3596 38.2759 23.5437 37.3972C21.6816 35.3991 20.4786 33.0663 20.1962 30.3465C19.6731 25.2939 21.5142 21.235 25.7195 18.4001C30.6676 15.0735 37.2475 15.8267 41.4214 20.0738C41.5469 20.1994 41.662 20.3563 41.7143 20.5237C41.798 20.7852 41.6725 21.0153 41.4319 21.1513C41.1703 21.2978 40.9297 21.2246 40.7205 21.0258C40.2289 20.5864 39.7477 20.1157 39.2141 19.7182C32.4459 14.7178 22.7068 18.7139 21.4096 27.0199C20.8657 30.5243 21.7758 33.6626 24.1504 36.2988C25.8974 38.2445 26.8075 40.4727 26.7552 43.0879C26.7447 43.454 26.7447 43.8202 26.7656 44.1863C26.8075 45.0546 27.4142 45.7241 28.2302 45.7345C30.5211 45.7554 32.8225 45.745 35.1553 45.745C35.1553 43.2239 35.1553 40.7133 35.1553 38.1713C33.4188 38.1713 31.6823 38.1713 29.8935 38.1713C29.8935 38.3177 29.8935 38.4537 29.8935 38.6002C29.8935 40.2948 29.8935 41.9895 29.8935 43.6842C29.8935 44.1131 29.7052 44.3432 29.3599 44.3746C29.0043 44.406 28.7323 44.1549 28.7218 43.7365C28.7114 43.2553 28.7218 42.7741 28.7218 42.2929C28.7218 40.0961 28.7218 37.9097 28.7218 35.7129C28.7218 35.2213 28.816 34.7819 29.2344 34.4681C29.2972 34.4158 29.3599 34.3216 29.3599 34.2484C29.3076 33.286 29.3076 32.3236 29.1507 31.3717C29.0252 30.6185 28.5545 29.9908 28.0209 29.4364C27.592 28.9866 27.5502 28.6727 27.8326 28.1392C28.8997 26.1307 30.155 24.2478 31.5986 22.4799C32.1739 21.779 32.9271 21.7894 33.5025 22.5008C34.9147 24.2478 36.1596 26.1098 37.237 28.0869C37.5509 28.6623 37.5404 28.9447 37.1115 29.4364C35.9085 30.8172 35.5947 32.4491 35.7411 34.217C35.7516 34.3112 35.8039 34.4158 35.8771 34.4681C36.2746 34.7819 36.3792 35.2004 36.3792 35.6816C36.3792 38.8617 36.3792 42.0523 36.3792 45.2324C36.3792 45.3893 36.3792 45.5358 36.3792 45.6822C37.4881 45.881 38.3354 45.1906 38.3459 44.1026C38.3563 42.8264 38.2936 41.5501 38.6493 40.2948C39.0363 38.9349 39.6535 37.7214 40.6159 36.6858C42.2583 34.9284 43.3358 32.9094 43.7019 30.5243C44.1099 27.8986 43.6391 25.4403 42.3315 23.1284C42.2897 23.0552 42.2478 22.9924 42.206 22.9297C41.9863 22.5322 42.0386 22.1974 42.3524 22.0091C42.6663 21.8208 42.9696 21.9464 43.2207 22.3439C46.0347 26.8735 45.4907 32.9826 41.8817 36.9996C40.867 38.1294 40.0092 39.3324 39.7372 40.8388C39.5698 41.7803 39.6012 42.7532 39.5175 43.7156C39.4757 44.2072 39.4652 44.7198 39.3083 45.1696C38.9945 46.0693 38.2936 46.5923 37.3312 46.8538C37.3312 47.8999 37.3416 48.9565 37.3312 50.0026C37.3207 50.9859 36.9232 51.7705 36.0759 52.2935C35.7934 52.4714 35.4587 52.5655 35.1553 52.691C33.3979 52.7224 31.6718 52.7224 29.9562 52.7224ZM33.2305 24.0595C33.1991 24.0699 33.1573 24.0908 33.1259 24.1013C33.1259 24.2478 33.1259 24.3838 33.1259 24.5302C33.1259 25.9006 33.1259 27.271 33.1259 28.6414C33.1259 28.7983 33.1573 28.997 33.084 29.1016C32.948 29.2795 32.7493 29.4782 32.5505 29.5201C32.2785 29.5828 32.0589 29.3841 31.9856 29.1016C31.9543 28.9656 31.9543 28.8192 31.9543 28.6727C31.9543 27.2605 31.9543 25.8587 31.9543 24.4465C31.9543 24.3105 31.9438 24.185 31.9333 23.9967C31.2952 24.6557 29.3076 27.658 28.9729 28.474C28.9415 28.5681 28.9729 28.725 29.0357 28.8087C29.747 29.6247 30.2073 30.5557 30.4374 31.6123C30.4583 31.7064 30.6048 31.8529 30.6989 31.8529C32.0066 31.8738 33.3037 31.8633 34.6323 31.8633C34.8938 30.7126 35.3854 29.6874 36.1177 28.7773C36.17 28.7146 36.1282 28.5263 36.0759 28.4426C35.5633 27.5848 35.0507 26.7165 34.5067 25.8692C34.0987 25.252 33.6594 24.6557 33.2305 24.0595ZM28.9624 48.4439C29.1612 48.4439 29.3076 48.4439 29.4646 48.4439C31.0337 48.4439 32.5924 48.4439 34.1615 48.4439C34.3184 48.4439 34.5172 48.4125 34.6218 48.4962C34.7892 48.6427 35.0088 48.8623 35.0088 49.0506C35.0088 49.2389 34.7682 49.4377 34.6009 49.5841C34.5067 49.6574 34.3289 49.626 34.1824 49.626C32.6028 49.626 31.0232 49.626 29.4436 49.626C29.2867 49.626 29.1403 49.626 28.9938 49.626C28.8055 50.7872 29.4227 51.5508 30.5316 51.5508C31.902 51.5508 33.2723 51.5613 34.6427 51.5508C35.511 51.5508 36.1177 50.9441 36.1386 50.0758C36.1491 49.7411 36.1386 49.3958 36.1386 49.0611C36.1386 48.3602 36.1386 47.6593 36.1386 46.9585C33.7326 46.9585 31.358 46.9585 28.9729 46.9585C28.9624 47.4397 28.9624 47.9104 28.9624 48.4439ZM35.1448 36.9369C35.1448 36.4034 35.1448 35.9117 35.1448 35.4305C33.3874 35.4305 31.6509 35.4305 29.9144 35.4305C29.9144 35.9431 29.9144 36.4243 29.9144 36.9369C31.6718 36.9369 33.3979 36.9369 35.1448 36.9369ZM30.5525 33.0559C30.5525 33.4638 30.5525 33.8404 30.5525 34.2066C31.8915 34.2066 33.1991 34.2066 34.5172 34.2066C34.5172 33.8091 34.5172 33.4429 34.5172 33.0559C33.1886 33.0559 31.8915 33.0559 30.5525 33.0559Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M21.5724 17.25C21.7607 17.3232 21.9071 17.3546 21.9908 17.4278C22.2837 17.6998 22.5662 17.9823 22.8277 18.2961C23.0369 18.5472 23.0055 18.8401 22.7754 19.0597C22.5557 19.2794 22.2628 19.3003 22.0327 19.1016C21.7084 18.8191 21.405 18.5158 21.1539 18.1706C21.0598 18.045 21.0702 17.7626 21.1435 17.5952C21.2062 17.4488 21.4259 17.3546 21.5724 17.25Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M44.0883 17.8326C44.0046 18.0105 43.9732 18.1465 43.8896 18.2406C43.628 18.5335 43.3665 18.8264 43.0841 19.0775C42.8435 19.2867 42.561 19.2867 42.31 19.0566C42.0693 18.8474 42.0484 18.5126 42.2786 18.2511C42.5296 17.9686 42.7702 17.6757 43.0736 17.4561C43.2305 17.341 43.5234 17.2991 43.7117 17.3724C43.8582 17.4351 43.9628 17.6757 44.0883 17.8326Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M33.0986 13.7548C33.0986 13.9535 33.1091 14.1523 33.0986 14.3406C33.0672 14.6753 32.858 14.8636 32.5337 14.8741C32.2304 14.8846 31.9898 14.7067 31.9688 14.3929C31.9375 13.964 31.9375 13.5351 31.9688 13.1062C31.9898 12.7924 32.2304 12.625 32.5442 12.625C32.879 12.6355 33.0777 12.8238 33.1091 13.1585C33.1091 13.3677 33.0986 13.5665 33.0986 13.7548Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M22.4546 39.0078C22.5801 39.102 22.7998 39.2066 22.8625 39.3635C22.9253 39.5413 22.9148 39.8238 22.8102 39.9702C22.5801 40.2945 22.2767 40.5665 21.9838 40.8385C21.7641 41.0372 21.4608 41.0582 21.2829 40.8385C21.1469 40.6816 21.0214 40.3154 21.1051 40.2004C21.4085 39.7924 21.7955 39.4472 22.1617 39.081C22.2035 39.0497 22.3081 39.0497 22.4546 39.0078Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M42.6666 38.9766C42.8549 39.0707 43.0013 39.1126 43.0955 39.2067C43.357 39.4578 43.6185 39.7088 43.8591 39.9808C44.0997 40.2633 44.0893 40.5875 43.8382 40.8177C43.6081 41.0269 43.2838 41.0374 43.0327 40.7968C42.7712 40.5457 42.4888 40.3051 42.2795 40.0122C42.1645 39.8448 42.1331 39.5624 42.1958 39.3741C42.2586 39.2067 42.4992 39.1126 42.6666 38.9766Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M17.6315 29.708C17.4327 29.708 17.2444 29.7185 17.0457 29.708C16.7319 29.6767 16.554 29.4884 16.5331 29.1745C16.5122 28.8607 16.6691 28.6096 16.9725 28.5783C17.4118 28.5364 17.8512 28.5364 18.2905 28.5783C18.5939 28.6096 18.7613 28.8607 18.7404 29.1641C18.7194 29.4674 18.5311 29.6662 18.2173 29.6976C18.029 29.729 17.8303 29.708 17.6315 29.708Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M47.4088 29.7068C47.21 29.7068 47.0217 29.7277 46.823 29.7068C46.5091 29.6754 46.3313 29.4662 46.3208 29.1628C46.3104 28.8699 46.4568 28.6293 46.7497 28.5979C47.1996 28.5561 47.6598 28.5456 48.0992 28.5979C48.4026 28.6293 48.549 28.8908 48.5281 29.2046C48.4967 29.5185 48.3084 29.6963 47.9946 29.7172C47.7958 29.7172 47.6075 29.7068 47.4088 29.7068Z'
                              fill='#0063AA'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_492_29514'>
                              <rect
                                width='32'
                                height='40.0863'
                                fill='white'
                                transform='translate(16.5312 12.6367)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='content'>
                        <p>02</p>
                        <div className='text text-white'>
                          <div>
                            <strong>{trans.offshore.step2}</strong>
                          </div>
                          {/* <span>Thiết kế kiến trúc hệ thống, phác thảo giao diện, thiết kế UI/UX
                                                    </span> */}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='icon'>
                        <svg
                          width='65'
                          height='65'
                          viewBox='0 0 126 126'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='62.5312'
                            cy='63.1797'
                            r='61.5901'
                            fill='#0063AA'
                            stroke='white'
                            stroke-width='1.81981'
                          />
                          <circle
                            cx='62.5312'
                            cy='63.1797'
                            r='54.6875'
                            fill='white'
                          />
                          <g clip-path='url(#clip0_492_29562)'>
                            <path
                              d='M31.2734 44.5005C31.6485 43.7504 31.9094 42.9025 32.4148 42.2503C33.328 41.0763 34.6487 40.6523 36.1489 40.6523C45.2964 40.6686 54.4439 40.6523 63.6078 40.6523C69.5757 40.6523 75.5273 40.6523 81.4952 40.6523C82.4409 40.6523 82.8812 40.9295 82.8975 41.5492C82.9138 42.1688 82.4409 42.4786 81.4626 42.4786C66.3634 42.4786 51.2806 42.4786 36.1815 42.4786C34.2085 42.4949 33.0997 43.5874 33.0997 45.5441C33.0997 46.3594 33.0997 47.1747 33.0997 47.9899C33.0997 48.4465 33.0997 48.9194 33.0997 49.4248C52.7318 49.4248 72.2987 49.4248 91.9146 49.4248C91.9146 47.8921 91.9961 46.3757 91.8983 44.8918C91.8168 43.5222 90.6427 42.5601 89.2404 42.5112C88.311 42.4786 87.3653 42.5112 86.4359 42.4949C86.2402 42.4949 86.0282 42.4949 85.8325 42.446C85.3434 42.3481 85.0825 42.0383 85.0988 41.5492C85.1151 41.06 85.3923 40.7013 85.8815 40.7013C87.2838 40.685 88.7024 40.5871 90.0883 40.7828C92.1918 41.06 93.7571 43.0004 93.7734 45.169C93.8061 47.142 93.7734 49.115 93.7734 51.088C93.7734 58.8659 93.7734 66.6274 93.7734 74.4053C93.7734 74.6336 93.7898 74.8618 93.7408 75.0738C93.6267 75.5467 93.3169 75.8076 92.8114 75.7913C92.3385 75.775 92.0613 75.4978 91.9635 75.0575C91.9146 74.8455 91.9309 74.6173 91.9309 74.389C91.9309 66.9698 91.9309 59.5344 91.9309 52.1153C91.9309 51.8707 91.9309 51.6261 91.9309 51.3489C72.3151 51.3489 52.7481 51.3489 33.0997 51.3489C33.0997 52.6371 33.0997 53.9089 33.0997 55.1971C33.0997 55.8982 32.6431 56.3711 32.0561 56.2243C31.7626 56.1102 31.5343 55.8004 31.2734 55.6047C31.2734 51.9033 31.2734 48.2019 31.2734 44.5005Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M31.2734 58.8987C31.5996 58.5236 31.9583 58.1812 32.5127 58.4095C33.0671 58.6378 33.0997 59.1106 33.0997 59.6324C33.0997 66.6765 33.0997 73.7043 33.0997 80.7484C33.0997 82.7866 34.1759 83.8791 36.2141 83.8791C53.7428 83.8791 71.2715 83.8791 88.8002 83.8791C90.8547 83.8791 91.9146 82.7866 91.9146 80.7484C91.9146 80.1125 91.8983 79.4928 91.9146 78.8569C91.9309 78.2373 92.2896 77.846 92.8114 77.8297C93.3332 77.8133 93.7408 78.221 93.7408 78.8243C93.7245 79.9005 93.7898 80.993 93.6267 82.0528C93.3006 84.0585 91.6048 85.5097 89.5829 85.6727C89.3057 85.689 89.0122 85.7053 88.735 85.7053C71.2715 85.7053 53.7917 85.7053 36.3282 85.7053C34.7629 85.7053 33.3606 85.314 32.3822 84.0422C31.8931 83.4062 31.6322 82.5746 31.2734 81.8409C31.2734 74.1935 31.2734 66.5461 31.2734 58.8987Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M79.7694 68.8113C77.2257 68.8113 74.682 68.8439 72.1383 68.795C70.2795 68.7624 69.0566 66.985 69.611 65.2566C69.9697 64.1315 70.9643 63.3488 72.2362 63.3325C77.2747 63.3162 82.3131 63.3162 87.3679 63.3325C88.9496 63.3325 90.1236 64.5718 90.1236 66.0882C90.1236 67.6047 88.9496 68.7787 87.3516 68.8113C84.8079 68.8439 82.2805 68.8276 79.7694 68.8113ZM79.7694 67.0013C82.1012 67.0013 84.4492 67.0013 86.7809 67.0013C87.0092 67.0013 87.2212 67.0013 87.4495 66.985C87.9386 66.9361 88.2321 66.6263 88.2647 66.1534C88.2974 65.6317 88.0039 65.3055 87.4984 65.2077C87.319 65.1751 87.1397 65.1751 86.9603 65.1751C82.1827 65.1751 77.4051 65.1751 72.6275 65.1751C72.4319 65.1751 72.2199 65.1751 72.0242 65.224C71.5513 65.3381 71.2904 65.6806 71.3231 66.1534C71.3557 66.61 71.6166 66.9035 72.0894 66.9687C72.3014 67.0013 72.5297 67.0013 72.758 67.0013C75.0897 67.0013 77.4214 67.0013 79.7694 67.0013Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M77.5016 76.1336C75.6753 76.1336 73.8491 76.1825 72.0228 76.1173C70.2129 76.0521 69.0226 74.1769 69.6422 72.4811C70.0335 71.4049 71.0119 70.6875 72.2185 70.6712C75.7732 70.6549 79.3278 70.6386 82.8825 70.6712C84.4641 70.6875 85.6055 71.9104 85.5892 73.4432C85.5729 74.9433 84.4315 76.101 82.8662 76.1336C81.0888 76.1662 79.2952 76.1499 77.5016 76.1336ZM77.5342 74.3237C79.2626 74.3237 80.991 74.3237 82.7031 74.3237C83.388 74.3237 83.763 73.9812 83.763 73.4105C83.763 72.8561 83.388 72.4974 82.7031 72.4974C79.2789 72.4811 75.8384 72.4974 72.4142 72.4974C72.2348 72.4974 71.9902 72.4811 71.8924 72.5953C71.6641 72.8398 71.338 73.1823 71.3706 73.4432C71.4032 73.7367 71.7456 74.0465 72.0065 74.2747C72.1533 74.3889 72.4305 74.3237 72.6588 74.3237C74.273 74.3237 75.9036 74.3237 77.5342 74.3237Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M75.1184 61.491C74.1889 61.491 73.2432 61.5073 72.3138 61.491C70.6669 61.4584 69.4929 60.3006 69.4766 58.7679C69.4766 57.2026 70.6832 56.0285 72.3464 56.0122C74.1563 55.9959 75.9663 55.9959 77.7762 56.0122C79.4557 56.0285 80.6786 57.1699 80.6949 58.719C80.7112 60.317 79.5046 61.4584 77.7925 61.491C76.8957 61.5073 75.9989 61.5073 75.1184 61.491C75.1184 61.5073 75.1184 61.5073 75.1184 61.491ZM75.0531 59.6647C75.9663 59.6647 76.8794 59.681 77.7925 59.6647C78.461 59.6484 78.8687 59.306 78.8687 58.7516C78.8687 58.2135 78.461 57.8385 77.7925 57.8385C75.9826 57.8222 74.1726 57.8222 72.379 57.8385C71.7105 57.8385 71.3191 58.1972 71.3028 58.7516C71.3028 59.2897 71.6941 59.6484 72.3627 59.6647C73.2758 59.681 74.1726 59.6647 75.0531 59.6647Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M54.8157 58.1303C54.7668 58.2934 54.7016 58.4891 54.6363 58.6847C52.5329 64.2287 50.4457 69.7563 48.3423 75.3003C48.0651 76.0177 47.5922 76.2786 47.0541 76.0667C46.5324 75.8547 46.3693 75.3492 46.6302 74.6807C48.7499 69.1041 50.8697 63.5275 52.9731 57.951C53.1688 57.4292 53.4786 57.1031 54.0656 57.2009C54.5385 57.2824 54.7505 57.6248 54.8157 58.1303Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M39.6589 66.6782C41.159 68.1784 42.5939 69.6133 44.0452 71.0645C44.2082 71.2275 44.3713 71.3743 44.5017 71.5537C44.7952 71.945 44.7789 72.3689 44.4528 72.7114C44.0941 73.0864 43.6701 73.119 43.2462 72.8255C43.132 72.744 43.0342 72.6461 42.9364 72.532C41.2732 70.8688 39.61 69.2056 37.9305 67.5261C37.2946 66.8902 37.2783 66.45 37.9142 65.814C39.6263 64.1019 41.3384 62.3898 43.0505 60.6777C43.5886 60.1559 44.0615 60.0907 44.4854 60.482C44.9257 60.8897 44.8767 61.4278 44.3387 61.9659C42.8059 63.5475 41.2569 65.0803 39.6589 66.6782Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M61.598 66.6583C60.0489 65.1093 58.5488 63.6254 57.0486 62.1416C56.9182 62.0112 56.7714 61.897 56.6736 61.734C56.3964 61.31 56.3964 60.8861 56.7714 60.5273C57.1302 60.1849 57.5378 60.1849 57.9292 60.4621C58.0596 60.5599 58.1737 60.6741 58.2879 60.7882C59.9348 62.4351 61.598 64.082 63.2448 65.7452C63.9786 66.4789 63.9786 66.8703 63.2285 67.6203C61.5816 69.2672 59.9348 70.9304 58.2553 72.561C58.027 72.7893 57.6193 72.9849 57.3095 72.9523C57.0486 72.9197 56.6736 72.5936 56.6084 72.3327C56.5432 72.0392 56.6899 71.5989 56.9019 71.3707C58.2716 69.9521 59.6739 68.5661 61.0599 67.1801C61.2555 67.0496 61.4023 66.8866 61.598 66.6583Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M47.885 46.0332C47.8687 47.5496 46.6131 48.7889 45.113 48.7562C43.6292 48.7399 42.4062 47.4844 42.4062 46.0169C42.4062 44.5167 43.6455 43.2612 45.1619 43.2775C46.6784 43.2775 47.885 44.5004 47.885 46.0332ZM45.1619 45.1037C44.6564 45.1037 44.2162 45.5277 44.2325 46.0169C44.2488 46.4897 44.6728 46.9137 45.1293 46.9137C45.6348 46.93 46.0587 46.4897 46.0424 45.9843C46.0424 45.4951 45.6511 45.1037 45.1619 45.1037Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M54.9796 46.0174C54.9796 47.5338 53.724 48.7731 52.2076 48.7568C50.7238 48.7405 49.5008 47.5012 49.4845 46.0174C49.4682 44.5173 50.7238 43.2617 52.2402 43.2617C53.7729 43.278 54.9796 44.4847 54.9796 46.0174ZM53.137 46.0011C53.137 45.4956 52.762 45.1206 52.2565 45.1043C51.751 45.088 51.3108 45.5119 51.3108 46.0174C51.3108 46.4903 51.7347 46.9142 52.1913 46.9305C52.7131 46.9305 53.137 46.5066 53.137 46.0011Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M40.7997 46.0006C40.7997 47.517 39.5442 48.7562 38.0441 48.7562C36.5439 48.7562 35.3047 47.4844 35.3047 45.9843C35.321 44.5004 36.5439 43.2775 38.0278 43.2775C39.5605 43.2612 40.7997 44.4841 40.7997 46.0006ZM38.9572 46.0332C38.9735 45.544 38.5821 45.1364 38.093 45.1038C37.5712 45.0711 37.1472 45.4788 37.1309 45.9843C37.1146 46.4897 37.5549 46.93 38.0441 46.9137C38.5332 46.9137 38.9572 46.506 38.9572 46.0332Z'
                              fill='#0063AA'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_492_29562'>
                              <rect
                                width='62.5'
                                height='45.0528'
                                fill='white'
                                transform='translate(31.2734 40.6523)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='content'>
                        <p>03</p>
                        <div className='text text-white'>
                          <div>
                            <strong>{trans.offshore.step3}</strong>
                          </div>
                          {/* <span>Lập trình các chức năng
                                                    </span> */}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='icon'>
                        <svg
                          width='65'
                          height='65'
                          viewBox='0 0 65 65'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='31.5'
                            fill='#0063AA'
                            stroke='white'
                          />
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='28'
                            fill='white'
                          />
                          <g clip-path='url(#clip0_492_29529)'>
                            <path
                              d='M16.5312 46.1121C16.6731 45.5195 17.0404 45.0938 17.466 44.6765C19.1437 43.0239 20.7962 41.3547 22.4655 39.6937C22.9329 39.2263 23.2417 39.2263 23.7091 39.6937C23.851 39.8356 23.9679 39.9942 24.0764 40.1194C24.886 39.3098 25.6455 38.5503 26.4217 37.7741C23.8343 34.7443 22.741 31.2389 23.3753 27.2743C23.8928 24.0026 25.5203 21.3401 28.1411 19.2952C33.2323 15.3307 40.6523 15.9316 45.0842 20.6557C49.5829 25.4548 49.6914 32.7829 45.3012 37.7574C40.8609 42.7902 32.8234 43.5832 27.4483 38.8007C26.6804 39.5602 25.9209 40.3197 25.1113 41.1293C25.2115 41.2211 25.3617 41.3463 25.4953 41.4799C25.9877 41.964 25.9877 42.2644 25.5036 42.7485C24.043 44.2091 22.5907 45.6614 21.1301 47.122C20.8881 47.3641 20.6377 47.5978 20.404 47.8565C20.0701 48.2154 19.7029 48.5325 19.2104 48.6744C19.0018 48.6744 18.7931 48.6744 18.5845 48.6744C17.5579 48.3907 16.8317 47.7897 16.5312 46.7381C16.5312 46.5294 16.5312 46.3208 16.5312 46.1121ZM35.8865 18.0099C29.6434 18.0099 24.5438 23.0761 24.5354 29.2858C24.5271 35.5706 29.5683 40.6619 35.8281 40.6786C42.0962 40.6953 47.2042 35.604 47.2042 29.3275C47.1958 23.1178 42.0962 18.0182 35.8865 18.0099ZM23.0498 41.0041C23.0414 41.0125 23.008 41.0292 22.983 41.0625C21.3304 42.7151 19.6778 44.3594 18.0419 46.0203C17.9334 46.1288 17.8834 46.3708 17.9251 46.5127C17.9919 46.7297 18.1421 46.9384 18.3174 47.097C18.693 47.4392 18.9851 47.4058 19.3356 47.0469C20.8964 45.4778 22.4572 43.917 24.0179 42.3562C24.0931 42.2811 24.1598 42.206 24.2099 42.1559C23.8176 41.772 23.4337 41.3881 23.0498 41.0041Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M35.8345 35.9961C31.895 35.971 28.8653 32.6325 29.2242 28.7097C29.508 25.6048 31.9785 23.0842 35.1084 22.7337C35.3421 22.7086 35.5841 22.6836 35.8262 22.6836C36.2268 22.6836 36.5189 22.959 36.5273 23.3263C36.5356 23.6935 36.2685 23.9856 35.8596 24.0023C34.5659 24.0441 33.389 24.4196 32.4209 25.2877C30.7432 26.7817 30.134 28.6596 30.7516 30.813C31.3859 32.9914 32.905 34.3017 35.1585 34.6106C38.2132 35.0362 40.8924 32.8495 41.1679 29.778C41.1846 29.6194 41.1846 29.4692 41.2012 29.3106C41.2346 28.9267 41.5184 28.6679 41.8773 28.6763C42.2362 28.6846 42.5116 28.9684 42.52 29.3523C42.5283 30.187 42.3697 30.9882 42.0693 31.7561C41.0677 34.3351 38.5805 36.0211 35.8345 35.9961Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M36.4467 29.721C37.3397 28.611 38.166 27.5677 39.0007 26.5327C39.7685 25.5729 40.5364 24.6131 41.3043 23.6532C41.5713 23.3194 41.9636 23.261 42.2641 23.4863C42.5812 23.7284 42.6146 24.1123 42.3476 24.4795C42.3142 24.5213 42.2808 24.563 42.2557 24.6047C41.2208 25.8984 40.1858 27.1921 39.1509 28.4774C38.4832 29.3037 37.8238 30.1384 37.1561 30.9647C36.7638 31.4487 36.3882 31.4654 35.9542 31.0314C35.1446 30.2218 34.3267 29.4122 33.5254 28.5943C33.4002 28.4691 33.2834 28.3022 33.2333 28.1269C33.1498 27.8431 33.3084 27.551 33.5672 27.4258C33.8676 27.2756 34.1347 27.334 34.3684 27.5677C34.986 28.177 35.5953 28.7863 36.2046 29.4039C36.2797 29.4873 36.3382 29.5875 36.4467 29.721Z'
                              fill='#0063AA'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_492_29529'>
                              <rect
                                width='32'
                                height='31.9917'
                                fill='white'
                                transform='translate(16.5312 16.6836)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='content'>
                        <p>04</p>
                        <div className='text text-white'>
                          <div>
                            <strong>{trans.offshore.step4}</strong>
                          </div>
                          {/* <span>Lập trình các chức năng
                                                    </span> */}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='icon'>
                        <svg
                          width='65'
                          height='65'
                          viewBox='0 0 65 65'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='31.5'
                            fill='#0063AA'
                            stroke='white'
                          />
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='28'
                            fill='white'
                          />
                          <g clip-path='url(#clip0_492_29540)'>
                            <path
                              d='M16.5312 31.6781C16.573 31.3607 16.6148 31.0433 16.6482 30.7259C16.6983 30.2748 16.9656 30.0159 17.3415 30.0577C17.7174 30.0911 17.9429 30.4001 17.8928 30.8512C17.7424 32.0707 17.7424 33.2819 17.8928 34.5014C18.2603 37.3915 19.3796 39.9475 21.2506 42.1694C23.2637 44.5583 25.7779 46.1955 28.81 46.9472C33.7215 48.1668 38.1736 47.1561 42.0661 43.9235C44.7056 41.735 46.3344 38.895 47.011 35.5288C48.406 28.621 44.5636 21.5711 38.0149 18.9817C32.4101 16.7765 26.2039 18.0796 21.9941 22.3646C21.9022 22.4565 21.8103 22.5567 21.6683 22.7155C22.0943 22.7155 22.4284 22.7155 22.7709 22.7155C23.0799 22.7155 23.3973 22.7071 23.7064 22.7322C24.0322 22.7572 24.2577 23.0245 24.2577 23.3419C24.2577 23.6426 24.0489 23.8932 23.7315 23.9517C23.6396 23.9684 23.5477 23.9684 23.4475 23.9684C22.4702 23.9684 21.4845 23.9684 20.5072 23.9684C19.9058 23.9684 19.697 23.7596 19.697 23.1582C19.697 22.114 19.6887 21.0699 19.7054 20.0342C19.7054 19.675 19.9476 19.4328 20.2817 19.4161C20.6325 19.3993 20.8915 19.6165 20.9416 19.9841C20.9583 20.0843 20.9499 20.1929 20.9499 20.2931C20.9499 20.7108 20.9499 21.1284 20.9499 21.6129C21.0585 21.521 21.1254 21.4709 21.1838 21.4124C23.8818 18.7228 27.1227 17.1357 30.9066 16.7598C39.4767 15.8995 46.5767 21.7549 48.1721 29.2558C49.851 37.166 45.5576 44.976 38.0651 47.7074C36.6868 48.2085 35.2668 48.5259 33.8051 48.6345C33.7132 48.6429 33.6213 48.6679 33.5294 48.6847C32.8612 48.6847 32.193 48.6847 31.5247 48.6847C31.4579 48.6679 31.3827 48.6429 31.3159 48.6345C30.5892 48.5259 29.8458 48.4591 29.1274 48.3088C22.9379 47.0725 17.7842 41.735 16.7818 35.5038C16.6816 34.9024 16.6148 34.2926 16.5312 33.6828C16.5312 33.0146 16.5312 32.3464 16.5312 31.6781Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M26.863 24.251C27.1386 24.393 27.456 24.4933 27.6899 24.6937C28.1994 25.1364 28.7507 25.2701 29.3688 25.0195C29.9703 24.7689 30.271 24.2928 30.3044 23.6329C30.3461 22.831 30.864 22.3716 31.6742 22.3633C32.2506 22.3633 32.8186 22.3633 33.3949 22.3633C34.2135 22.3633 34.7147 22.8394 34.7732 23.658C34.84 24.6353 35.6085 25.2784 36.5523 25.103C36.8196 25.0529 37.1036 24.8942 37.3208 24.7188C37.9723 24.1842 38.6322 24.1842 39.2336 24.7856C39.6513 25.1949 40.0606 25.6042 40.4699 26.0219C41.0044 26.5731 41.0295 27.2748 40.5116 27.8428C40.0606 28.3356 39.9436 28.8869 40.1859 29.4883C40.4281 30.0897 40.8959 30.4071 41.5641 30.4405C42.366 30.4823 42.8421 31.0002 42.8504 31.7937C42.8504 32.3701 42.8504 32.9381 42.8504 33.5144C42.8504 34.3581 42.3827 34.8509 41.539 34.9094C40.5784 34.9762 39.9269 35.7613 40.1107 36.7052C40.1608 36.9725 40.3279 37.2482 40.5033 37.4653C41.0128 38.0835 41.0212 38.7684 40.4532 39.3364C40.0355 39.7624 39.6179 40.18 39.1919 40.5977C38.6322 41.149 37.9306 41.1657 37.3542 40.6394C36.8614 40.1967 36.3101 40.0798 35.7087 40.3304C35.1156 40.5726 34.8066 41.032 34.7732 41.6836C34.7314 42.5105 34.2219 42.9783 33.4033 42.9866C32.8269 42.9866 32.2589 42.9866 31.6826 42.9866C30.864 42.9866 30.3628 42.5105 30.3044 41.6919C30.2375 40.7146 29.4691 40.0715 28.5252 40.2469C28.2579 40.297 27.9739 40.4557 27.7567 40.6311C27.1219 41.1573 26.4453 41.1573 25.8606 40.581C25.4346 40.1633 25.017 39.7457 24.5993 39.3197C24.0647 38.7684 24.0397 38.0668 24.5576 37.4988C25.0086 37.0143 25.1256 36.4546 24.8833 35.8532C24.6411 35.2518 24.1733 34.9344 23.5051 34.901C22.7032 34.8592 22.2271 34.3414 22.2188 33.5478C22.2188 32.9715 22.2188 32.4035 22.2188 31.8271C22.2188 30.9835 22.6865 30.4907 23.5302 30.4322C24.4824 30.3654 25.1256 29.6053 24.9669 28.6614C24.9167 28.3774 24.758 28.0934 24.5743 27.8678C24.0647 27.2414 24.0564 26.5648 24.6244 25.9968C25.0504 25.5624 25.4764 25.1364 25.9107 24.7188C26.1947 24.4432 26.4871 24.3179 26.8296 24.3179C26.8296 24.3095 26.8463 24.2761 26.863 24.251ZM23.48 33.6481C24.6912 33.7149 25.5683 34.2578 26.0277 35.3688C26.4954 36.4881 26.2449 37.5071 25.4764 38.3591C25.9441 38.8269 26.3869 39.2779 26.8463 39.7373C27.715 38.9605 28.7257 38.7266 29.8366 39.1777C30.9642 39.6371 31.4988 40.5309 31.5657 41.7253C32.2255 41.7253 32.8604 41.7253 33.5035 41.7253C33.5704 40.5225 34.1133 39.6455 35.2242 39.1777C36.3435 38.7099 37.3626 38.9689 38.2229 39.729C38.6907 39.2612 39.1417 38.8185 39.5928 38.3591C38.816 37.4904 38.5737 36.4881 39.0332 35.3688C39.4926 34.2411 40.3863 33.7065 41.5808 33.6314C41.5808 32.9715 41.5808 32.345 41.5808 31.6935C40.378 31.6267 39.5009 31.0837 39.0415 29.9728C38.5737 28.8535 38.8243 27.8344 39.5928 26.9741C39.125 26.5063 38.6823 26.0636 38.2229 25.6042C37.3542 26.381 36.3519 26.6233 35.2409 26.1639C34.1216 25.7044 33.5704 24.8107 33.5035 23.6162C32.8437 23.6162 32.2172 23.6162 31.5657 23.6162C31.4988 24.819 30.9559 25.6961 29.845 26.1555C28.7257 26.6233 27.7066 26.3727 26.8463 25.6042C26.3785 26.072 25.9274 26.5147 25.468 26.9741C26.2449 27.8428 26.4871 28.8535 26.0277 29.9644C25.5683 31.0837 24.6745 31.6267 23.4717 31.6935C23.48 32.3701 23.48 32.9882 23.48 33.6481Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M37.2236 32.6821C37.2236 35.2631 35.1103 37.3764 32.5292 37.3681C29.9482 37.3681 27.8432 35.2464 27.8516 32.6654C27.8599 30.101 29.9649 27.9961 32.5292 27.9961C35.1103 27.9961 37.2236 30.101 37.2236 32.6821ZM35.9706 32.6737C35.9623 30.786 34.4003 29.2407 32.5125 29.249C30.6331 29.2574 29.0962 30.8027 29.0962 32.6821C29.0962 34.5698 30.6498 36.1235 32.5376 36.1235C34.4337 36.1151 35.979 34.5615 35.9706 32.6737Z'
                              fill='#0063AA'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_492_29540'>
                              <rect
                                width='32'
                                height='32.0084'
                                fill='white'
                                transform='translate(16.5312 16.6758)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='content'>
                        <p>05</p>
                        <div className='text text-white'>
                          <div>
                            <strong>{trans.offshore.step5}</strong>
                          </div>
                          {/* <span>Triển khai chạy thử, chạy beta và chạy production
                                                    </span> */}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className='icon'>
                        <svg
                          width='65'
                          height='65'
                          viewBox='0 0 65 65'
                          fill='none'
                          xmlns='http://www.w3.org/2000/svg'
                        >
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='31.5'
                            fill='#0063AA'
                            stroke='white'
                          />
                          <circle
                            cx='32.5312'
                            cy='32.6797'
                            r='28'
                            fill='white'
                          />
                          <g clip-path='url(#clip0_492_29550)'>
                            <path
                              d='M16.5312 29.8061C16.6564 29.2115 16.8207 28.6325 17.2198 28.1552C17.3919 27.9518 17.5797 27.7562 17.7831 27.5684C18.276 27.1068 18.5264 26.5435 18.4794 25.8706C18.4168 24.9161 18.6437 24.0555 19.2853 23.32C19.6765 22.8662 20.1537 22.5533 20.7249 22.3655C21.4838 22.1151 21.9533 21.6066 22.2271 20.8633C22.7904 19.3533 23.9484 18.5709 25.5757 18.6335C26.3738 18.6648 26.9997 18.3988 27.5396 17.8198C28.6427 16.6384 29.9806 16.3724 31.4515 17.0374C32.187 17.3738 32.8755 17.3738 33.611 17.0374C35.0662 16.3724 36.4119 16.6384 37.4995 17.8041C38.0628 18.4066 38.6965 18.6726 39.518 18.6413C41.0985 18.5865 42.2721 19.3689 42.8198 20.8477C43.1014 21.6144 43.5943 22.1073 44.3689 22.389C45.8476 22.9367 46.63 24.1103 46.5674 25.6907C46.5361 26.5122 46.8022 27.1538 47.4046 27.7093C48.5625 28.789 48.8364 30.1425 48.1792 31.5743C47.8349 32.3332 47.8349 33.0296 48.1792 33.7885C48.8364 35.2125 48.5547 36.5817 47.4046 37.6535C46.8022 38.209 46.5361 38.8506 46.5674 39.6721C46.6222 41.2526 45.8398 42.4183 44.3611 42.9738C43.5943 43.2633 43.1014 43.7484 42.8198 44.523C42.2799 46.0095 41.0437 46.8076 39.4555 46.7293C38.6809 46.6902 38.055 46.9328 37.5464 47.5274C37.03 48.1376 36.3728 48.5054 35.5748 48.6306C35.5357 48.6384 35.4965 48.6618 35.4652 48.6775C35.1914 48.6775 34.9254 48.6775 34.6515 48.6775C34.1665 48.5054 33.6814 48.3254 33.1963 48.1611C32.7503 48.0046 32.2965 48.0046 31.8584 48.1611C31.3733 48.3254 30.8882 48.5054 30.4031 48.6853C30.1528 48.6853 29.9024 48.6853 29.652 48.6853C28.8227 48.5288 28.0872 48.2081 27.5317 47.5508C27.0154 46.9406 26.366 46.7059 25.5679 46.7293C23.9484 46.7841 22.7904 46.0095 22.2271 44.4995C21.9454 43.7562 21.476 43.2477 20.7249 42.9973C20.1616 42.8095 19.6765 42.4966 19.2853 42.0428C18.6515 41.3073 18.4246 40.4467 18.4794 39.4922C18.5185 38.8193 18.276 38.256 17.7831 37.7944C17.5875 37.6144 17.3997 37.4188 17.2198 37.2076C16.8207 36.7303 16.6564 36.1513 16.5313 35.5645C16.5313 35.3142 16.5313 35.0638 16.5313 34.8134C16.7034 34.3284 16.8833 33.8433 17.0555 33.3582C17.2119 32.9122 17.2119 32.4584 17.0555 32.0203C16.8912 31.5352 16.7112 31.0501 16.5313 30.565C16.5312 30.3068 16.5312 30.0565 16.5312 29.8061ZM45.3234 25.8706C45.3782 24.564 44.9479 23.9303 43.7352 23.4765C42.7493 23.1088 42.0843 22.4281 41.7166 21.4423C41.2941 20.2843 40.629 19.8306 39.4007 19.8853C38.321 19.9323 37.4369 19.5567 36.7014 18.7665C35.8721 17.8589 35.1053 17.7181 33.9865 18.2345C33.0085 18.6883 32.0462 18.6883 31.0682 18.2345C29.9572 17.7181 29.1826 17.8667 28.3533 18.7665C27.6256 19.5567 26.7337 19.9323 25.654 19.8853C24.4256 19.8306 23.7606 20.2843 23.3381 21.4501C22.9704 22.4516 22.2897 23.1244 21.2882 23.4922C20.1224 23.9147 19.6765 24.5797 19.7313 25.8159C19.7782 26.8956 19.4026 27.7797 18.6124 28.5151C17.7048 29.3523 17.5562 30.1112 18.0804 31.2301C18.5342 32.2081 18.5342 33.1704 18.0804 34.1484C17.564 35.2594 17.7127 36.034 18.6124 36.8633C19.4026 37.5909 19.7782 38.4829 19.7313 39.5626C19.6765 40.7909 20.1303 41.4638 21.2882 41.8785C22.2897 42.2384 22.9704 42.9269 23.3303 43.9205C23.7528 45.0863 24.4178 45.5323 25.654 45.4775C26.7337 45.4306 27.6178 45.8061 28.3454 46.5963C29.1748 47.4961 29.9572 47.6447 31.0603 47.1284C32.0383 46.6746 33.0007 46.6746 33.9787 47.1284C35.074 47.6447 35.8643 47.4961 36.6701 46.612C37.4134 45.7983 38.3132 45.4149 39.4163 45.4697C40.6056 45.5244 41.2863 45.0628 41.6931 43.9362C42.0608 42.9112 42.7572 42.2227 43.7743 41.8472C44.0559 41.7455 44.3376 41.6125 44.5645 41.4325C45.1591 40.9631 45.3547 40.3137 45.3078 39.5704C45.2295 38.4672 45.6207 37.5596 46.4423 36.8242C46.5753 36.7068 46.7083 36.5817 46.81 36.4408C47.3498 35.7132 47.3655 34.9543 46.9665 34.1562C46.4814 33.1704 46.4892 32.1768 46.9665 31.1831C47.0525 31.0032 47.1308 30.8232 47.1777 30.6354C47.389 29.7592 47.076 29.0706 46.4188 28.4995C45.652 27.811 45.2843 26.9269 45.3234 25.8706Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M35.1077 29.3035C36.0153 29.3035 36.8838 29.2957 37.7601 29.3035C38.7615 29.3113 39.4892 29.992 39.5517 30.97C39.5517 30.9778 39.5596 30.9935 39.5517 31.0013C39.3561 31.5333 39.6613 31.815 40.0134 32.1671C40.7253 32.8869 40.5767 34.084 39.763 34.6942C39.6926 34.749 39.6143 34.8038 39.5283 34.8585C39.8334 35.8365 39.5517 36.5955 38.6755 37.1275C38.6755 37.1588 38.6676 37.1901 38.6755 37.2135C39.0275 38.4732 38.2451 39.5294 36.9307 39.5373C35.2016 39.5451 33.4725 39.5373 31.7434 39.5373C31.008 39.5373 30.296 39.3964 29.6153 39.1226C29.4667 39.06 29.3728 39.0991 29.2319 39.1774C28.9503 39.3338 28.6373 39.506 28.3244 39.5216C27.4324 39.5686 26.5327 39.5529 25.6407 39.5373C24.8349 39.5216 24.2403 38.9348 24.2324 38.129C24.2246 35.6644 24.2246 33.192 24.2324 30.7275C24.2324 29.906 24.8349 29.3113 25.6564 29.3035C26.5405 29.2879 27.4246 29.28 28.3087 29.3113C28.5747 29.3192 28.8564 29.4287 29.0989 29.5539C29.2554 29.64 29.3571 29.6556 29.5136 29.5695C30.1239 29.2409 30.7263 28.9123 31.094 28.2942C31.2583 28.0126 31.407 27.7074 31.5244 27.3945C31.806 26.6668 32.0564 25.9314 32.3224 25.1959C32.5337 24.6248 32.8153 24.4996 33.3865 24.7187C34.9356 25.3133 35.7728 27.0033 35.3268 28.615C35.2564 28.8419 35.186 29.061 35.1077 29.3035ZM33.316 26.1192C33.0892 26.7529 32.8623 27.3554 32.651 27.9578C32.3693 28.7558 31.939 29.4444 31.2583 29.9529C30.8359 30.2659 30.3508 30.5006 29.9048 30.7822C29.8187 30.837 29.7249 30.9622 29.717 31.0561C29.7092 33.2546 29.7092 35.4453 29.717 37.6439C29.717 37.7378 29.8187 37.8864 29.897 37.9021C30.476 38.0507 31.0627 38.262 31.6495 38.2776C33.3943 38.3245 35.1469 38.3011 36.8994 38.2933C37.2906 38.2933 37.5253 38.0898 37.5175 37.7847C37.5097 37.4874 37.2828 37.2996 36.9072 37.2996C36.5865 37.2918 36.2579 37.3074 35.9371 37.2918C35.5537 37.2761 35.2799 37.0179 35.272 36.6815C35.2642 36.3294 35.5459 36.0634 35.9449 36.0478C36.297 36.04 36.6491 36.0478 37.009 36.0478C37.2984 36.0478 37.5958 36.0556 37.8852 36.04C38.1826 36.0243 38.386 35.8131 38.3938 35.547C38.3938 35.281 38.1904 35.0776 37.8931 35.0463C37.807 35.0385 37.7288 35.0463 37.6427 35.0463C37.0872 35.0463 36.5395 35.0541 35.984 35.0463C35.5537 35.0385 35.272 34.7803 35.272 34.4204C35.2799 34.0605 35.5615 33.8101 35.9918 33.8023C36.2109 33.7945 36.43 33.8023 36.6491 33.8023C37.3219 33.8023 38.0026 33.8101 38.6755 33.7945C38.9884 33.7866 39.2075 33.5676 39.1997 33.2859C39.1918 33.0199 38.9884 32.8243 38.6833 32.8008C38.5972 32.793 38.519 32.8008 38.4329 32.8008C37.6192 32.8008 36.8055 32.8008 35.9997 32.8008C35.5694 32.8008 35.2799 32.5505 35.272 32.1906C35.2642 31.815 35.5537 31.5646 36.0075 31.5568C36.2579 31.549 36.5082 31.5568 36.7586 31.5568C37.1028 31.5568 37.4471 31.5646 37.7914 31.549C38.0965 31.5333 38.2921 31.3299 38.2921 31.0639C38.2921 30.7901 38.1043 30.5866 37.7992 30.5632C37.7131 30.5554 37.6349 30.5632 37.5488 30.5632C36.4691 30.5632 35.3816 30.5632 34.3019 30.5632C33.762 30.5632 33.4882 30.1876 33.6525 29.6634C33.7777 29.2566 33.9341 28.8576 34.0593 28.4507C34.3566 27.5118 34.1063 26.7138 33.316 26.1192ZM28.473 34.4439C28.473 33.2546 28.4652 32.0732 28.4808 30.884C28.4808 30.6414 28.4026 30.5475 28.1601 30.5554C27.3777 30.5632 26.5953 30.5632 25.8207 30.5554C25.5625 30.5554 25.4764 30.6492 25.4764 30.8996C25.4843 33.2546 25.4843 35.6096 25.4764 37.9568C25.4764 38.215 25.5547 38.3089 25.8207 38.3011C26.5874 38.2854 27.362 38.2854 28.1288 38.3011C28.4104 38.3089 28.4887 38.1994 28.4808 37.9334C28.4652 36.7754 28.473 35.6096 28.473 34.4439Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M19.9101 32.3949C20.0353 27.0042 23.5874 22.2472 28.7512 20.6433C32.0764 19.6184 35.3077 19.947 38.4138 21.5118C38.7972 21.7074 38.9302 22.0594 38.7581 22.388C38.6016 22.701 38.2417 22.8105 37.874 22.6306C36.7708 22.0751 35.6207 21.6761 34.4001 21.4726C28.3835 20.479 22.6642 24.391 21.4202 30.3607C20.9429 32.6531 21.1541 34.8907 22.0461 37.058C22.1008 37.191 22.1634 37.324 22.2104 37.4648C22.3199 37.8169 22.1791 38.1455 21.8661 38.2707C21.5375 38.4037 21.1933 38.2707 21.0524 37.903C20.8255 37.3318 20.5986 36.7607 20.4187 36.1817C20.0353 34.969 19.8788 33.6389 19.9101 32.3949Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M33.1441 45.2891C30.9612 45.3282 29.2243 44.9918 27.5656 44.2876C27.1431 44.1077 26.9788 43.7713 27.1197 43.427C27.2683 43.0827 27.6204 42.9576 28.0429 43.1375C29.5529 43.7713 31.1177 44.0999 32.7529 44.0529C35.8668 43.9747 38.5113 42.8011 40.6864 40.5791C42.3764 38.85 43.3778 36.7688 43.7456 34.3825C44.0977 32.1214 43.7769 29.9463 42.8223 27.8651C42.7285 27.6539 42.6111 27.4583 42.525 27.247C42.3607 26.8637 42.4624 26.5194 42.7832 26.3629C43.1118 26.2065 43.4404 26.3316 43.636 26.6994C44.348 28.0373 44.8096 29.4456 45.0131 30.9478C45.4434 34.226 44.7392 37.2461 42.8223 39.9453C40.8977 42.6602 38.2844 44.3659 35.014 45.0309C34.2864 45.1874 33.5275 45.2422 33.1441 45.2891Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M24.0636 40.547C24.4 40.5549 24.6973 40.8522 24.6973 41.1886C24.6973 41.5172 24.4156 41.7989 24.087 41.8067C23.7428 41.8067 23.422 41.4859 23.4298 41.1495C23.4377 40.8209 23.7271 40.5392 24.0636 40.547Z'
                              fill='#0063AA'
                            />
                            <path
                              d='M41.6504 24.2042C41.6583 24.5328 41.3844 24.8223 41.048 24.8301C40.7037 24.8379 40.4064 24.5563 40.3986 24.212C40.3908 23.8756 40.6646 23.5861 40.9932 23.5783C41.3218 23.5705 41.6426 23.8678 41.6504 24.2042Z'
                              fill='#0063AA'
                            />
                          </g>
                          <defs>
                            <clipPath id='clip0_492_29550'>
                              <rect
                                width='32'
                                height='31.9922'
                                fill='white'
                                transform='translate(16.5312 16.6836)'
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div className='content'>
                        <p>06</p>
                        <div className='text text-white'>
                          <div>
                            <strong>{trans.offshore.step6}</strong>
                          </div>
                          {/* <span>Đánh giá chất lượng,
                                                        hiệu năng

                                                    </span> */}
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end step */}
      </div>
    </>
  );
}
